import { useMediaQuery, useTheme } from '@mui/material';
// import { getInsufficiencyList } from './insufficiency';

export function useIsDesktop() {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up(1024));
  return isDesktop;
}

// export function useGetInsufficiencies(responseList, insufficiencyDataList) {
//   const [insufsFiltered, setInsufsFiltered] = useState([]);
//   const [insufsResolvedFiltered, setInsufsResolvedFiltered] = useState({});

//   useEffect(() => {
//     let insufs = [];
//     let insufsResolved = {
//       insuf: [],

//       resolution: {
//       }
//     };

//     responseList?.forEach((response, i) => {
//       if (response?.insufficiencyData) {
//         const foundResolved = insufficiencyDataList ? insufficiencyDataList?.findLast((x) => x?.responseIndex === i) : null;
//         const insuff = getInsufficiencyList(response?.insufficiencyData, foundResolved, insufsResolved);
//         insufs = [...insufs, ...insuff.unresolved];
//         insufsResolved = insuff.resolved;
//       }
//     });

//     setInsufsFiltered(insufs);
//     setInsufsResolvedFiltered(insufsResolved);
//   }, []);

//   return ({
//     insufsFiltered,
//     insufsResolvedFiltered
//   });
// }
